import { FC, ReactNode } from 'react'

import { Box, Ellipsis, TagBar, Text } from '@revolut-internal/ui-kit'

import { TAG_MAX_WIDTH } from 'consts/ui'
import { humanize } from 'utils/format'

type TagsCellProps = {
  tags: string[]
  renderTag?: (tag: string, index: number) => ReactNode
}

const defaultTagRenderer = (tag: string, index: number) => (
  <TagBar.Item key={index}>
    <Text variant="emphasis4" fontWeight={600} color="grey-tone-50">
      <Ellipsis maxWidth={TAG_MAX_WIDTH} tooltip="auto">
        {humanize(tag ?? '')}
      </Ellipsis>
    </Text>
  </TagBar.Item>
)

export const TagsCell: FC<TagsCellProps> = ({ tags, renderTag = defaultTagRenderer }) => {
  if (!tags.length) {
    return null
  }

  return (
    <Box px="s-12">
      <TagBar onClick={e => e.stopPropagation()}>{tags.map(renderTag)}</TagBar>
    </Box>
  )
}
